module.exports = __webpack_public_path__ + "static/media/paiement.8a28a907.png";